import React from 'react';

type Props = {
  root?: React.RefObject<HTMLDivElement>;
  target: React.RefObject<HTMLDivElement>;
  onIntersect: () => void;
  threshold?: number;
  rootMargin?: string;
  enabled: boolean;
};

export const useIntersectionObserver = ({
  root,
  target,
  onIntersect,
  threshold = 0.5,
  rootMargin = '0px',
  enabled = true,
}: Props) => {
  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => entry.isIntersecting && onIntersect()),
      {
        root: root && root.current,
        rootMargin,
        threshold,
      },
    );

    const el = target && target.current;

    if (!el) {
      return;
    }

    observer.observe(el);

    return () => {
      observer.unobserve(el);
    };
  }, [enabled, onIntersect, root, rootMargin, target, threshold]);
};
